import styled from 'styled-components'
import { Row } from 'react-flexbox-grid'
import { Checkbox } from 'components/forms'

// ─── KitchenPrinters / PrinterRecord (shared) ────────────────────────────────

export const HighlightedRow = styled(Row)`
	margin-bottom: 0.5rem;
	padding: 20px;
	background-color: #f4f3f384;
	border-radius: 5px;
	min-height: 170px;
`

export const SCheckbox = styled(Checkbox)`
	label {
		align-items: center;
	}
`

// ─── Receipt – top section (logo + checkboxes) ───────────────────────────────

export const ReceiptSettingsTitle = styled.div`
	font-family: 'Plus Jakarta Sans', Roboto, sans-serif;
	font-size: 14px;
	font-weight: 600;
	line-height: 100%;
	letter-spacing: 0;
	color: ${({ theme }) => theme.fieldLabelColor || '#555'};
	margin-bottom: 14px;
`

// ─── Receipt – printer list ───────────────────────────────────────────────────

export const PrinterListTitle = styled.div`
	font-family: 'Plus Jakarta Sans', Roboto, sans-serif;
	font-size: 14px;
	font-weight: 600;
	line-height: 100%;
	letter-spacing: 0;
	color: ${({ theme }) => theme.fieldLabelColor || '#555'};
	margin: 24px 0 12px;
`

export const PrinterList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 980px;
	max-width: 100%;
`

export const ReceiptPrinterRow = styled.div`
	border: 1px solid ${({ theme }) => theme.colors?.border || '#e0e0e0'};
	border-radius: 10px;
	padding: 16px 24px 24px;
	background: #fff;
	box-sizing: border-box;
	min-height: 116px;
	width: 100%;
`

export const ReceiptPrinterHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 10px;
	color: ${({ theme }) => theme.colors?.text || '#333'};
	font-size: 13px;
	font-weight: 600;
`

export const ReceiptPrinterFields = styled.div`
	display: grid;
	grid-template-columns: ${({ columns }) => `repeat(${columns || 1}, minmax(0, 300px))`};
	gap: 12px;
	align-items: flex-start;
	max-width: 100%;

	> div {
		width: 300px;
		max-width: 100%;
		min-width: 0;
	}

	@media (max-width: 1200px) {
		grid-template-columns: 1fr;

		> div {
			width: 100%;
		}
	}
`

export const PrinterActions = styled.div`
	margin-top: 12px;
`

export const DeletePrinterButton = styled.button`
	width: 34px;
	height: 34px;
	padding: 0;
	border: 0;
	background: transparent;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: rgba(0, 0, 0, 0.56);
	cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
	opacity: ${({ disabled }) => disabled ? 0.35 : 1};

	svg {
		width: 20px;
		height: 20px;
	}
`
